<template>
  <q-card
    class="column justify-between"
    style="background-color: #f2f2f2"
  >
    <span
      class="provision"
      style="padding: 16px 16px 0 16px"
    >Agendamento</span>
    <PanelEvent
      ref="eventPanel"
      @form-error="updateSaveButton"
      :attendance="attendance"
      :date="date"
      :is-paused="isPaused"
    />

    <q-card-section class="row justify-between">
      <q-btn
        data-testid="agenda-cancelar"
        color="primary"
        label="Cancelar"
        no-caps
        flat
        v-close-popup
      />

      <q-btn
        data-testid="agenda-agendar"
        color="primary"
        label="Agendar"
        no-caps
        :disable="disableSave"
        :loading="loadingState"
        @click="handleEventsAppointment"
      />
    </q-card-section>
  </q-card>
</template>

<script>

import { v4 as uuidv4 } from 'uuid'
import moment from 'moment-timezone'
import PanelEvent from './PanelEvent.vue'
moment.locale('pt-br')
export default {
  components: { PanelEvent },

  props: {
    agentId: {},
    date: {},
    attendance: {},
    timeSelected: {},
    isPaused: {}
  },

  data () {
    return {
      attendanceInfo: null,
      tab: 'Evento',
      loadingState: false,
      disableSave: false,
      notification: {}
    }
  },

  mounted () {
    this.attendanceInfo = this.attendance
      ? JSON.parse(this.attendance)
      : null
  },

  computed: {
    channelText () {
      const channel = this.attendanceInfo?.channel
      if (channel === 'MAIL') return 'atendimento por email'
      if (channel === 'TEXT') return 'atendimento de chat'
      return 'atendimento de voz'
    },

    getEventPanelData () {
      const formInfo = this.$refs.eventPanel.getFormData()
      return formInfo
    },

    isChat () {
      return this.attendanceInfo?.channel === 'TEXT'
    },

    isMail () {
      return this.attendanceInfo?.channel === 'MAIL'
    },

    isVoice () {
      return this.attendanceInfo?.channel === 'VOICE'
    }

  },

  methods: {
    formatDate (date) {
      return moment(date).format('dddd, D [de] MMMM')
    },

    async handleEventsAppointment () {
      this.loadingState = true
      const { title, description, phoneNumber, backgroundColor, startDate, endDate, notificationTimeBefore, contact } = this.getEventPanelData

      const templateToSend = this.getEventPanelData?.templateToSend || null
      const configs = { title, description, phoneNumber, backgroundColor, notificationTimeBefore, templateToSend }

      const appointment = { id: `${Date.now()}-${uuidv4()}`, agentId: this.agentId, configs, startDate, endDate, contact, templateId: templateToSend?.id ?? null }

      if (this.attendanceInfo) {
        const attendance = { ...this.attendanceInfo }
        delete attendance.info
        delete attendance.messages
        delete attendance.mailBody
        appointment.attendanceInfo = JSON.stringify(attendance)
      }

      const newAppointments = await this.$store.dispatch('calendarModule/saveAppointment', appointment)
      this.loadingState = false
      this.$emit('close-calendar', newAppointments)
    },

    updateSaveButton (formHasError) {
      this.disableSave = Boolean(formHasError)
    },

    updateNotifications (notification) {
      this.notification = notification
    }
  }

}

</script>
<style lang="sass">

.mx-datepicker-popup
  z-index: 9999 !important
.provision
  font-weight: 500
  font-size: 18px
</style>
